import { LocationUtils } from '@ctct/rise-utils';
import { useTranslations } from 'next-intl';
import { type ComponentProps, useMemo } from 'react';

import { type InputOpts } from '../../../types';
import { DropdownInput, type DropdownItem } from '../../inputs-core';

const ProvinceCodeDropdown = ({
  formKey,
  registerOpts,
  ...selectProps
}: InputOpts & ComponentProps<typeof DropdownInput>) => {
  const t = useTranslations('UiForm');
  const emptyValue = useMemo(() => ({ label: t('shared.province.placeholder'), value: '-' }), [t]);
  const dropdownItems: DropdownItem[] = LocationUtils.provinces.map((province) => ({
    label: province.name,
    value: province.abbreviation,
  }));
  return (
    <DropdownInput
      formKey={formKey}
      registerOpts={registerOpts}
      placeholder={t('shared.province.placeholder')}
      items={dropdownItems}
      emptyValue={emptyValue}
      {...selectProps}
    />
  );
};

export { ProvinceCodeDropdown };
